import { render, staticRenderFns } from "./CourseRating.vue?vue&type=template&id=4c7f7afe&"
import script from "./CourseRating.vue?vue&type=script&lang=ts&"
export * from "./CourseRating.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports